// extracted by mini-css-extract-plugin
export var card = "_8j-1";
export var container = "_8j-0";